import {
  fieldInstallationFeeAmount,
  secureBusinessSectionsVulcan,
  secureBusinessPlanVulcan
} from '../../../utils/constant';

export const secureBusinessPlan = secureBusinessPlanVulcan;
export const secureBusinessOffersVulcan = 'secureBusinessOffersVulcan';
export const optionSecureBusiness = 'Telus Secure Business';
export const pricingFields = [
  fieldInstallationFeeAmount,
  secureBusinessOffersVulcan,
  secureBusinessPlanVulcan
];

export const setPricingFields = (
  formFields,
  isThisOrderData,
  equipmentBlobs
) => {
  const addedFields = new Set(pricingFields);
  // Equipment sections are `custom`/blob-shaped in the engine — never
  // tree-walked into fieldStates — so `formFields[section]` is always
  // undefined for the (!isThisOrderData) fieldStates call. `equipmentBlobs`
  // (each section's `engine.values[section]`, passed explicitly by the
  // caller) is the real source there; `orderData` (the isThisOrderData call)
  // already carries its sections directly and needs no substitute.
  const source = isThisOrderData ? formFields : equipmentBlobs || formFields;
  if (source && Object.keys(source).length > 0) {
    secureBusinessSectionsVulcan.forEach(section => {
      const sectionFields = source[section];
      if (sectionFields) {
        if (!isThisOrderData) {
          Object.values(sectionFields).forEach(field => {
            if (field.name && !addedFields.has(field.name)) {
              pricingFields.push(field.name);
              addedFields.add(field.name);
            }
          });
        } else {
          Object.keys(sectionFields).forEach(field => {
            if (field && !addedFields.has(field)) {
              pricingFields.push(field);
              addedFields.add(field);
            }
          });
        }
      }
    });
  }
};
